const languageOptions = {
  es: 'spanish',
  en: 'english',
};

export default languageOptions;
